import { AppSelect } from '@app/shared/components/AppSelect';
import { withEditPermissionCheck } from '@app/shared/hocs/withEditPermissionCheck';

export const RoleProtectedSelect = withEditPermissionCheck(AppSelect);
